import { Modal } from 'antd'
import Button from 'components/Button/index'
import Flex from 'components/Flex'
import { Form } from 'components/UIComponents/FormStyles'
import CheckedWhite from 'components/icons/CheckedWhite'
import AddtionalInfo from 'modules/Settings/Components/AddtionalInfo/index'
import CompanyInfo from 'modules/Settings/Components/CompanyInfo/index'
import Location from 'modules/Settings/Components/Location'
import TaxInfo from 'modules/Settings/Components/TaxInfo/index'
import {
  PaddedDiv,
  SectionWrapper,
  StyledTabs,
  TopHeader,
  TopHeading,
} from 'modules/Settings/Styles/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import SuccessMessage from 'utils/SuccessMessage'
import { getYear } from 'utils/getYear'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'
import { permittedCruds } from '../../utils/permissionsValidation'
const { confirm } = Modal

const Settings = ({
  corporateData,
  getIndustries,
  industriesList,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  getUserRoles,
  userRoles,
  updateCorporateDetails,
  getCorporateLocationsList,
  corporateLocationsList,
  addCorporateBranch,
  getLocationDetails,
  singleLocationData,
  updateLocationAPI,
  deleteLocationAPI,
  permissions,
}) => {
  const [settingsForm] = Form.useForm()
  const [selectedTab, setSelectedTab] = useState('COMPANY')
  const [searchIndustry, setSearchIndustry] = useState('')
  const [logoFile, setLogoFile] = useState(null)
  const [isFieldsChanged, setIsFieldsChanged] = useState(false)

  const [selectedCountry, setSelectedCountry] = useState({})
  const [selectedState, setSelectedState] = useState({})
  const [selectedCity, setSelectedCity] = useState({})
  const [socialMediaList, setSocialMediaList] = useState([])

  const [presentationFile, setPresentationFile] = useState(null)

  const [updateLoading, setUpdateLoading] = useState(false)

  const [aboutWarning, setAboutWarning] = useState(false)

  const [countryCodeSearch, setCountryCodeSearch] = useState('')
  const [countryCodeList, setCountryCodeList] = useState([])
  const [shortDescription, setShortDescription] = useState('')


  const initializeFormData = () => {
    setSearchIndustry(corporateData?.industry)
    setLogoFile(corporateData?.logo)
    setSocialMediaList(corporateData?.socialMedia || [])
    if (corporateData?.corporatePresentationLink) {
      setPresentationFile({ url: corporateData?.corporatePresentationLink })
    }
    settingsForm.setFieldsValue({
      logo: corporateData?.logo,
      companyName: corporateData?.name,
      websiteLink: corporateData?.website,
      industry: corporateData?.industry,
      numberOfEmployee: corporateData?.employeesNumber,
      establishedYear: corporateData?.establishedYear
        ? moment(corporateData?.establishedYear, 'YYYY')
        : '',
      shortDescription: corporateData?.shortDescription,
      aboutCompany: corporateData?.longDescription,
      addressOne: corporateData?.addressLine1,
      addressTwo: corporateData?.addressLine2,
      companyCountry: corporateData?.country,
      companyState: corporateData?.state,
      companyCity: corporateData?.city,
      companyZipcode: corporateData?.postalCode,
      contactPersonName: corporateData?.contactPerson,
      contactPersonRole: corporateData?.contactPersonRole,
      countryCode: corporateData?.countryCode || '91',
      companyPhone: corporateData?.contactNumber,
      companyEmail: corporateData?.contactEmail,
      corporateVideoLink: corporateData?.corporateVideoLink,

      companyPAN: corporateData?.pan,
      companyGST: corporateData?.gst,
    })
    setShortDescription(corporateData?.shortDescription)
    corporateData?.socialMedia?.map((item, index) =>
      settingsForm.setFieldsValue({ [item?.media + index]: [item?.link] })
    )
  }
  useEffect(() => {
    initializeFormData()
  }, [corporateData])

  useEffect(() => {
    if (
      logoFile != corporateData?.logo ||
      (presentationFile?.url &&
        presentationFile?.url != corporateData?.corporatePresentationLink)
    ) {
      onChangeFormFields()
    } else {
      setIsFieldsChanged(false)
    }
  }, [logoFile, presentationFile])

  const getCurrency = async ({ setState, searchValue }) => {
    const { data, status } = await getListOfCountries({
      phoneCodeSearch: searchValue?.trim(),
      pageLimit: 500,
    })

    if (status >= 200 && status <= 300) {
      setState(removeDuplicatesFromArray(data?.data?.result, 'phone_code'))
    }
  }

  useEffect(() => {
    let getData
    if (countryCodeSearch) {
      getData = setTimeout(() => {
        getCurrency({
          setState: setCountryCodeList,
          searchValue: countryCodeSearch,
        })
      }, 500)
    } else {
      getCurrency({
        setState: setCountryCodeList,
        searchValue: countryCodeSearch,
      })
    }

    return () => clearTimeout(getData)
  }, [countryCodeSearch])

  const onChangeFormFields = () => {
    setIsFieldsChanged(true)

    if (
      !settingsForm.getFieldValue('aboutCompany') ||
      settingsForm.getFieldValue('aboutCompany') == '<p><br></p>'
    ) {
      setAboutWarning(true)
    } else {
      setAboutWarning(false)
    }
  }

  const onSubmitFormData = async values => {
    let payload = {}
    setUpdateLoading(true)
    if (selectedTab === 'COMPANY') {
      payload = {
        companyInfo: {
          logo: logoFile,
          name: values?.companyName?.trim(),
          website: /^https?:\/\//i.test(values?.websiteLink)
            ? values?.websiteLink
            : `https://${values?.websiteLink}`,
          industry: values?.industry,
          employeesNumber: values?.numberOfEmployee,
          establishedYear: getYear(values?.establishedYear),
          shortDescription: values?.shortDescription?.trim(),
          longDescription: values?.aboutCompany,
          addressLine1: values?.addressOne?.trim(),
          addressLine2: values?.addressTwo?.trim(),
          city: selectedCity?.name,
          state: selectedState?.name,
          country: selectedCountry?.name,
          cityId: selectedCity?._id,
          stateId: selectedState?._id,
          countryId: selectedCountry?._id,
          postalCode: values?.companyZipcode,
          countryCode: values?.countryCode,
          contactNumber: values?.companyPhone,
          contactEmail: values?.companyEmail,
          contactPerson: values?.contactPersonName?.trim(),
          contactPersonRole: values?.contactPersonRole || '',
        },
      }
    }
    if (selectedTab === 'ADDINFO') {
      payload = {
        additionalInfo: {
          corporatePresentationLink: presentationFile?.url
            ? presentationFile?.url
            : null,
          corporateVideoLink: values?.corporateVideoLink
            ? /^https?:\/\//i.test(values?.corporateVideoLink)
              ? values?.corporateVideoLink
              : `https://${values?.corporateVideoLink}`
            : null,
          socialMedia: socialMediaList
            ?.filter(item => item?.link)
            ?.map(data => {
              return {
                ...data,
                link: /^https?:\/\//i.test(data?.link)
                  ? data?.link
                  : `https://${data?.link}`,
              }
            }),
        },
      }
    }
    if (selectedTab === 'TAXINFO') {
      payload = {
        taxInfo: {
          pan: values?.companyPAN?.toUpperCase(),
          gst: values?.companyGST?.toUpperCase(),
        },
      }
    }

    const { status } = await updateCorporateDetails(payload)

    if (status >= 200 && status <= 300) {
      SuccessMessage('Updated Successfully')
      setIsFieldsChanged(false)
      setUpdateLoading(false)
    } else {
      setUpdateLoading(false)
    }
  }

  const cruds = permittedCruds(permissions, 'Settings')

  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading height="40px">Settings</TopHeading>
          {selectedTab != 'LOCATION' && cruds?.includes('SAVE CHANGES') && (
            <Flex>
              <Button.Primary
                icon={<CheckedWhite />}
                height="32px"
                text={'Save Changes'}
                width={'144px'}
                form={'settingsForm'}
                htmlType="submit"
                loading={updateLoading}
              />
            </Flex>
          )}
        </TopHeader>
        <Form
          scrollToFirstError
          onFieldsChange={onChangeFormFields}
          onFinish={onSubmitFormData}
          id={'settingsForm'}
          form={settingsForm}
          layout="vertical"
        >
          <StyledTabs
            activeKey={selectedTab}
            onChange={key => {
              if (isFieldsChanged) {
                confirm({
                  zIndex: '1001',
                  title: <p>Changes are not saved. Please save the changes!</p>,
                  okText: 'Ignore Changes',
                  okType: 'primary',
                  cancelText: 'Go Back',
                  onOk: () => {
                    initializeFormData()
                    setSelectedTab(key)
                    setIsFieldsChanged(false)
                  },
                  width: 'fit-content',
                })
              } else {
                setSelectedTab(key)
                setIsFieldsChanged(false)
              }
            }}
            items={[
              {
                key: 'COMPANY',
                label: 'Company Info',
                children: selectedTab === 'COMPANY' && (
                  <CompanyInfo
                    getIndustries={getIndustries}
                    industriesList={industriesList}
                    searchIndustry={searchIndustry}
                    setSearchIndustry={setSearchIndustry}
                    corporateData={corporateData}
                    file={logoFile}
                    setFile={setLogoFile}
                    getListOfCountries={getListOfCountries}
                    getListOfStates={getListOfStates}
                    getListOfCities={getListOfCities}
                    selectedCountry={selectedCountry}
                    setSelectedCountry={setSelectedCountry}
                    selectedState={selectedState}
                    setSelectedState={setSelectedState}
                    selectedCity={selectedCity}
                    setSelectedCity={setSelectedCity}
                    getUserRoles={getUserRoles}
                    userRoles={userRoles}
                    settingsForm={settingsForm}
                    aboutWarning={aboutWarning}
                    presentationFile={presentationFile}
                    setCountryCodeSearch={setCountryCodeSearch}
                    countryCodeList={countryCodeList}
                    shortDescription={shortDescription}
                    setShortDescription={setShortDescription}
                  />
                ),
              },
              {
                key: 'ADDINFO',
                label: 'Additional Info',
                children: selectedTab === 'ADDINFO' && (
                  <AddtionalInfo
                    corporateData={corporateData}
                    socialMediaList={socialMediaList}
                    setSocialMediaList={setSocialMediaList}
                    presentationFile={presentationFile}
                    setPresentationFile={setPresentationFile}
                    onChangeFormFields={onChangeFormFields}
                    settingsForm={settingsForm}
                  />
                ),
              },
              {
                key: 'TAXINFO',
                label: 'Tax Info',
                children: selectedTab === 'TAXINFO' && (
                  <TaxInfo
                    corporateData={corporateData}
                    settingsForm={settingsForm}
                  />
                ),
              },

              {
                key: 'LOCATION',
                label: 'Location',
                children: (
                  <Location
                    getListOfCountries={getListOfCountries}
                    getListOfStates={getListOfStates}
                    getListOfCities={getListOfCities}
                    listOfCountries={listOfCountries}
                    listOfStates={listOfStates}
                    listOfCities={listOfCities}
                    getCorporateLocationsList={getCorporateLocationsList}
                    corporateLocationsList={corporateLocationsList}
                    addCorporateBranch={addCorporateBranch}
                    getLocationDetails={getLocationDetails}
                    singleLocationData={singleLocationData}
                    updateLocationAPI={updateLocationAPI}
                    deleteLocationAPI={deleteLocationAPI}
                  />
                ),
              },
            ]}
          />
        </Form>
      </PaddedDiv>
    </SectionWrapper>
  )
}

export default Settings
